import Backdrop, { BackdropProps } from '@mui/material/Backdrop';
import { grey } from '@mui/material/colors';
import { withTheme, makeStyles } from '@mui/styles';
import styled from 'styled-components';
import 'react-calendar/dist/Calendar.css';

export const CalendarContainer = withTheme(styled.div`
position: relative;

.react-calendar {
  font-family: 'Heavent';
  width: 100%;
  border: none;

  .react-calendar__navigation {
    margin-bottom: 0;

    .react-calendar__navigation__label {
      font-size: 18px;
    }

    button {
      min-width: 35px;
    }

    button:enabled:hover, button:enabled:focus {
      background-color: initial;
    }
    
    button:disabled {
      background-color: initial;
      color: inherit;
    }

    .custom-navigation.Mui-disabled {
      box-shadow: 0px 3px 5px -1px rgb(0 0 0 / 20%), 0px 6px 10px 0px rgb(0 0 0 / 14%), 0px 1px 18px 0px rgb(0 0 0 / 12%);
      background-color: ${() => grey.A100};

      svg {
        color: rgba(0, 0, 0, 0.38);
      }
    }
  }

  .react-calendar__month-view__weekdays {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);

    abbr {
      text-decoration: none;
      font-size: 18px;
    }
  }

  .react-calendar__tile {
    padding: 4px;
    width: 42px;
    height: 42px;
    position: relative;
  }
    

  .react-calendar__tile:disabled {
    background-color initial;
  }

  .react-calendar__tile--now::before,
  .react-calendar__tile:disabled.react-calendar__tile--now::before {
    content: '';
    display: inline-block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.04);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  button {
    font-family: 'Heavent';

    abbr {
      font-size: 18px;

      & + .optional-text {
        font-size: 11px;
      }
    }
  }

  .optional-text {
    position: absolute;
    bottom: 1px;
    left: 50%;
    transform: translate(-50%, 0);
    width: 100%;
  }

  ${(props: any) => props.theme.breakpoints.between('375', 'md')} {
    width: 336px;

    .react-calendar__tile {
      width: 48px;
      height: 48px;
    }

    button {
      abbr {
        & + .optional-text {
          font-size: 14px;
        }
      }
    }
  }

  ${(props: any) => props.theme.breakpoints.up('md')} {
    width: 560px;
    min-width: 560px;
    
    .react-calendar__navigation {
      .react-calendar__navigation__label {
        font-size: 24px;
      }
    }
    .react-calendar__month-view__weekdays {
      abbr {
        font-size: 24px;
      }
    }
    .react-calendar__tile {
      width: 80px;
      height: 60px;
    }

    button {
      abbr {
        font-size: 24px;

        & + .optional-text {
          font-size: 18px;
        }
      }
    }

    .optional-text {
      bottom: 8px;
    }

    .react-calendar__tile--now::before,
    .react-calendar__tile:disabled.react-calendar__tile--now::before {
      width: 50px;
      height: 50px;
    }
  }

  ${(props: any) => props.theme.breakpoints.between('lg', '1350')} {
    width: 448px;
    min-width: 448px;

    .react-calendar__tile {
      width: 64px;
      height: 64px;
    }

    button {
      abbr {
        & + .optional-text {
          font-size: 16px;
        }
      }
    }
  }
}

.react-calendar__tile--active:enabled:hover, .react-calendar__tile--active:enabled:focus {
  color: ${(props: any) => props.theme.palette.primary.main};
  border-style: solid;
  border-color: ${(props: any) => props.theme.palette.primary.main};
  background-color initial;
}

.react-calendar__month-view__days__day--weekend, .react-calendar__month-view__days__day--neighboringMonth {
    color: revert;
}

.selectable-date {
  color: ${(props: any) => props.theme.palette.primary.main};
  border-width: 1px;
  border-style: solid;
  border-color: ${(props: any) => props.theme.palette.primary.main};
  background-color initial;
}

.selectable-date.react-calendar__tile--active:enabled:hover,
.selectable-date.react-calendar__tile--active:enabled:focus,
.react-calendar__tile:enabled:hover,
.react-calendar__tile:enabled:focus {
  background-color: rgba(0,0,0,0.04);
}

.selected-date, .end-date, .react-calendar__tile:disabled.end-date, .selected-date:hover, .selected-date:focus,
.selected-date.react-calendar__tile--active:enabled:focus, .selected-date.react-calendar__tile--active:enabled:hover,
.selected-date.react-calendar__month-view__days__day--neighboringMont.react-calendar__tile--active:enabled:focus,
.selected-date.react-calendar__tile--rangeStart
{
  background: ${(props: any) => props.theme.palette.primary.main};
  color: #ffffff;
}

.between-training-date, .react-calendar__tile:disabled.between-training-date {
  background: rgba(0, 83, 42, 0.12);
  color: ${(props: any) => props.theme.palette.primary.main};
}

${(props: any) => props.theme.breakpoints.between('375', 'md')} {
  display: flex;
  justify-content: center;
}

${(props: any) => props.theme.breakpoints.up('md')} {
  display: flex;
  justify-content: center;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  padding: 10px 96px;
}

${(props: any) => props.theme.breakpoints.up('lg')} {
  padding: 16px 56px;
  border: 1px solid ${grey.A400};
}`);

export const BackdropStyle = styled(Backdrop)<BackdropProps>(({ theme }) => ({
  position: 'absolute',
  backgroundColor: 'white',
  borderRadius: '10px',
}));

export const useFabCssClasses = makeStyles((theme: any) => ({
  sizeSmall: {
    width: '35px',
    height: '35px',
    [theme.breakpoints.up('sm')]: {
      width: '40px',
      height: '40px',
    },
  },
}));
